import createRouter, { generateRoutes } from '@/global/router'
import Login from '@/global/views/Login/index'
import store from '../store'

export const routeData = [
  {
    path: '/home',
    name: 'home',
    title: '首页面板',
    icon: 'icon-move',
    component: () => import('@/global/views/home-panel/index.vue'),
    meta: { platform: 'agency' }
  },
  {
    path: '/staff',
    name: 'staff',
    title: '员工管理',
    icon: 'icon-move',
    component: () => import('@/agent/views/staff/index.vue'),
    includePages: [
      {
        path: '/staff/:type/:id?',
        name: 'addStaff',
        component: () => import('@/agent/views/staff/add.vue')
      }
    ]
  },
  /* {
    path: '/advertiser',
    name: 'advertiser',
    title: '广告主管理',
    icon: 'icon-guanggaozhu',
    component: () => import('@/agent/views/advertiser/advertiser.vue'),
    includePaths: ['/addAdvertiser', '/editAdvertiser', '/showAdvertiser'],
    includePages: [
      {
        path: '/addAdvertiser',
        name: 'addAdvertiser',
        component: () => import('@/agent/views/advertiser/addAdvertiser.vue')
      },
      {
        path: '/editAdvertiser/:id',
        name: 'editAdvertiser',
        component: () => import('@/agent/views/advertiser/addAdvertiser.vue')
      },
      {
        path: '/showAdvertiser/:id',
        name: 'showAdvertiser',
        component: () => import('@/agent/views/advertiser/addAdvertiser.vue')
      }
    ]
  }, */
  {
    path: '/userList',
    name: 'nameList',
    title: '子账户管理',
    icon: 'icon-zhanghaoguanli',
    meta: { platform: 'agency' },
    component: () => import('@/agent/views/subAccount/user_list.vue'),
    includePaths: ['/oprUser', '/oprAgencyUser'],
    includePages: [
      {
        name: 'oprUser',
        path: '/oprUser/:id',
        meta: { platform: 'agency' },
        component: () => import('@/agent/views/subAccount/opr_user.vue')
      },
      {
        name: 'oprAgencyUser',
        meta: { platform: 'agency' },
        path: '/oprAgencyUser/:id/:userType?/:donewsStatus?/:type',
        component: () => import('@/agent/views/subAccount/opr_agency_user.vue')
      }
    ]
  },
  {
    name: 'AdPut',
    title: '广告投放',
    icon: 'icon-flag',
    children: [
      {
        path: '/advertiser',
        name: 'advertiser',
        meta: { platform: 'agency' },
        title: '广告主管理',
        component: () => import('@/agent/views/ad-put/advertiser/index.vue'),
        includePaths: [],
        includePages: [
          {
            path: '/advertiser/add',
            name: 'advertiser/add',
            component: () => import('@/agent/views/ad-put/advertiser/add.vue')
          },
          {
            path: '/advertiser/edit/:id',
            name: 'advertiser/edit/:id',
            component: () => import('@/agent/views/ad-put/advertiser/add.vue')
          }
        ]
      },
      {
        path: '/groups',
        name: 'groups',
        title: '广告组管理',
        meta: { platform: 'agency' },
        component: () => import('@/agent/views/ad-put/group/index.vue'),
        includePaths: ['/group/type', '/group/add', '/group/edit', '/group/view', 'group/copy'],
        includePages: [
          {
            path: '/group/:type/:id?',
            name: 'group/type',
            meta: { platform: 'agency' },
            component: () => import('@/agent/views/ad-put/group/add.vue')
          }
        ]
      },
      {
        path: '/plans',
        name: 'plans',
        meta: { platform: 'agency' },
        title: '计划管理',
        component: () => import('@/agent/views/ad-put/plan/index.vue'),
        includePaths: ['/plan/add', '/plan/edit', '/plan/view', '/plan/copy'],
        includePages: [
          {
            path: '/plan/add',
            name: 'plan/add',
            meta: { platform: 'agency' },
            component: () => import('@/agent/views/ad-put/plan/add.vue')
          },
          {
            path: '/plan/edit/:id',
            meta: { platform: 'agency' },
            name: 'plan/edit',
            component: () => import('@/agent/views/ad-put/plan/add.vue')
          },
          {
            path: '/plan/view/:id',
            meta: { platform: 'agency' },
            name: 'plan/view',
            component: () => import('@/agent/views/ad-put/plan/add.vue')
          },
          {
            path: '/plan/copy/:id',
            meta: { platform: 'agency' },
            name: 'plan/copy',
            component: () => import('@/agent/views/ad-put/plan/add.vue')
          }
        ]
      },
      {
        path: '/creations',
        name: 'creations',
        title: '创意管理',
        meta: { platform: 'agency' },
        component: () => import('@/agent/views/ad-put/creation/index.vue'),
        includePaths: ['/creation/type', '/creation/add', '/creation/edit', '/creation/view', 'creation/copy'],
        includePages: [
          {
            path: '/creation/:type/:id?',
            name: 'creation/type',
            meta: { platform: 'agency' },
            component: () => import('@/agent/views/ad-put/creation/add2.vue')
          }
        ]
      }
    ]
  },
  /*  { // 隐藏用户菜单需求
    name: 'ApplicationManage',
    title: '应用推广',
    icon: 'icon-flag',
    children: [
      {
        path: '/promotions',
        name: 'promotions',
        title: '推广管理',
        meta: { platform: 'agency' },
        component: () => import('@/agent/views/application/promotion/index.vue'),
        includePaths: ['/promotion/type', '/promotion/add', '/promotion/edit', '/promotion/view', 'promotion/copy'],
        includePages: [
          {
            path: '/promotion/:type/:id?',
            name: 'promotion/type',
            meta: { platform: 'agency' },
            component: () => import('@/agent/views/application/promotion/add.vue')
          }
        ]
      },
      {
        path: '/channels',
        name: 'channels',
        title: '渠道包管理',
        meta: { platform: 'agency' },
        component: () => import('@/agent/views/application/channel-pkg/index.vue'),
        includePaths: ['/channel/type', '/channel/add', '/channel/edit', '/channel/view'],
        includePages: [
          {
            path: '/channel/:type/:id?',
            name: 'channel/type',
            meta: { platform: 'agency' },
            component: () => import('@/agent/views/application/channel-pkg/add.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/promotion-data',
    name: 'promotion-data',
    title: '推广数据',
    icon: 'icon-pie',
    meta: { platform: 'agency' },
    component: () => import('@/agent/views/promotion/data.vue')
  }, */
  // {
  //   name: 'advertisePut',
  //   title: '广告投放',
  //   icon: 'icon-flag',
  //   children: [
  //     {
  //       path: '/orderList/nofilter',
  //       name: 'orderList',
  //       title: '计划管理',
  //       meta: { platform: 'agency' },
  //       component: () => import('@/agent/views/advertise_put/order_list.vue'),
  //       includePaths: ['/orderAdd', '/orderOpr'],
  //       includePages: [
  //         {
  //           path: '/orderAdd/:media?',
  //           name: 'orderAdd',
  //           meta: { platform: 'agency' },
  //           component: () => import('@/agent/views/advertise_put/order_opr.vue')
  //         },
  //         {
  //           path: '/orderOpr/:id?/:type?/:media?',
  //           name: 'orderOpr',
  //           meta: { platform: 'agency' },
  //           component: () => import('@/agent/views/advertise_put/order_opr.vue')
  //         }
  //       ]
  //     },
  //     {
  //       path: '/advertiseList',
  //       name: 'advertiseList',
  //       title: '广告管理',
  //       component: () => import('@/agent/views/advertise_put/advertise_list.vue'),
  //       includePaths: ['/advertiseAdd'],
  //       includePages: [
  //         {
  //           path: '/advertiseAdd/:type?/:id?',
  //           name: 'advertiseAdd',
  //           component: () => import('@/agent/views/advertise_put/advertise_opr.vue')
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    path: '/dataReport',
    name: 'dataReport',
    title: '数据报表',
    icon: 'icon-pie',
    meta: { platform: 'agency' },
    component: () => import('@/global/views/data_report_ad.vue')
  },
  {
    path: '/audience',
    name: 'audience',
    title: '受众分析',
    icon: 'icon-pie',
    meta: { platform: 'agency' },
    component: () => import('@/global/views/audience-analysis/index.vue')
  },
  {
    name: 'financeManage',
    title: '财务管理',
    icon: 'icon-icon15',
    children: [
      {
        path: '/finDetails',
        name: 'finDetails',
        title: '财务明细',
        component: () => import('@/agent/views/financial/finDetails.vue')
      },
      {
        path: '/editFinancial',
        name: 'editFinancial',
        title: '财务编辑',
        component: () => import('@/agent/views/financial/editFinancial.vue')
      }
    ]
  },
  {
    name: 'account',
    title: '账号管理',
    icon: 'icon-zhanghaoguanli',
    children: [
      {
        path: '/accountInfo',
        name: 'accountInfo',
        title: '账户详情',
        component: () => import('@/agent/views/account/accountInfo.vue')
      },
      {
        path: '/passwordSet',
        name: 'passwordSet',
        title: '密码设置',
        component: () => import('@/agent/views/account/passwordSet.vue')
      }
    ]
  },
  {
    path: 'tool',
    name: 'tool',
    title: '工具',
    icon: 'icon-flag',
    meta: { platform: 'agency' },
    children: [
      {
        name: 'operationLog',
        path: '/operationLog',
        meta: { platform: 'agency' },
        title: '操作日志',
        component: () => import('@/global/views/tool/operationLog.vue')
      },
      {
        name: 'transferEvent',
        path: '/transferEvent',
        meta: { platform: 'agency' },
        title: '转化事件管理',
        component: () => import('@/global/views/tool/transferEvent.vue')
      }
    ]
  }
]

let routeDataFilter = routeData.filter(item => {
  // eslint-disable-next-line no-undef
  return item.name === 'audience' && VUE_APP_ENV === 'online' ? false : item
})
const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { platform: 'agency', path: 'home' }
  },
  {
    path: '/',
    meta: { platform: 'agency' },
    component: () => import('@/agent/views/main.vue'),
    children: generateRoutes(routeDataFilter, true)
  }
]
export default createRouter({ base: '/agent/', routes, routeData: routeDataFilter }, store, 'agency')
